module.exports = __webpack_public_path__ + "assets/img/swiper-1.4fdcc611.jpg";